import logClientEvent, {LogStrategy} from "surveylabJsAssets/common/_client-event-logging";
import {doAjax} from "surveylabJsAssets/common/_ajax";

/**
 * @param {JQuery<HTMLElement>} $tile
 * @param {number} val
 */
function changeTile($tile: JQuery<HTMLElement>, val: number): void {
    // Apply new value to tile
    $tile.removeClass('tile-value-0 tile-value-1 tile-value-2');
    $('.js-tile-value-text', $tile).addClass('d-none');
    $('.js-tile-value-text-' + val, $tile).removeClass('d-none');
    if (!(val < 0)) {
        $tile.addClass('tile-value-' + val);
    }
    $tile.attr('data-value', val.toString());
}

/**
 * Returns the next value (iterating through [0, 1, 2]).
 *
 * @param {JQuery<HTMLElement>} $tileElement
 * @returns {number}
 */
function getValue($tileElement: JQuery<HTMLElement>): number {
    const currentValue = parseInt($tileElement.attr('data-value') as string);
    return (currentValue + 1) % 3;
}

export default function () {
    // Clickhandler for tiles
    $('main > div').not('.survey-overiew').on('click', '.js-tile', function () {
        const $tile = $(this);
        // noinspection JSJQueryEfficiency
        const isUserSurvey = $("input[name='hidden-user-survey-id']").length !== 0;
        // Do nothing for disabled tiles
        if ($tile.attr('disabled') !== 'disabled') {
            $tile.attr('disabled', 'disabled');
            const val = getValue($tile);
            const itemID = $tile.data('item-id');
            if (isUserSurvey) {
                const $surveyElementDiv = $tile.closest('.survey-element');
                const itemInput = {
                    'itemID': itemID,
                    'itemValue': val,
                    'pageID': $("input[name='hidden-page-id']").val(),
                    'userSurveyID': $("input[name='hidden-user-survey-id']").val(),
                    'surveyElementID': $surveyElementDiv.data('survey-element-id')
                };

                const saveUrl = $('#save-item-input-url').val() as string;
                const jqXHR = doAjax({url: saveUrl, data: itemInput});
                jqXHR.done(function () {
                    changeTile($tile, val);
                    // Log client event
                    const TYPE_ITEM_INPUT = 20; // Item input value change
                    logClientEvent(TYPE_ITEM_INPUT, LogStrategy.update, {'itemID': itemID});
                });
                jqXHR.always(function () {
                    $tile.removeAttr('disabled');
                });
            } else {
                $tile.removeAttr('disabled');
                changeTile($tile, val);
            }
        }
    });

    // Check if Mobile & remove class if true
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        $('.no-mobile').removeClass('no-mobile');
    }
}